// import firebaseUi from '../vendors/firebase-ui-auth.js';
import firebase from 'firebase';
//import firebaseUiAuthCss from '../vendors/firebase-ui-auth.css'; /* eslint no-unused-vars: 0 */

const user = {
  displayName: undefined,
  email: undefined,
  emailVerified: false,
  photoURL: undefined,
  uid: undefined,
  authenticated: undefined,
};



const login = function login(id,pass) {
  firebase.auth().signInWithEmailAndPassword(id,pass)
}

const init = function init() {

	firebase.auth().signInAnonymously().catch(function(error) {
	  var errorCode = error.code;
	  var errorMessage = error.message;
	  //console.log(errorCode)
	  //console.log(errorMessage)
	  //console.log('ADA')
	  //globals.database_loaded = true
	})

  firebase.auth().onAuthStateChanged((theUser) => {

    globals.authentication_checked = true
    eventBus.$emit('onAuthChecked')
    var user = {}
    //globals.database_loaded = true
    globals.firebase_connected = true

    if (theUser) {
      user.displayName = theUser.displayName;
      user.email = theUser.email;
      user.emailVerified = theUser.emailVerified;
      user.photoURL = theUser.photoURL;
      user.uid = theUser.uid;
      user.authenticated = true
      // Object.assign(user, theUser);
      //console.log('user found');
      //console.log(user.uid);
      eventBus.$emit('onAuthLogin',user)
    } else {
      // User is signed out.
      //console.log('no user found');
      user.displayName = undefined;
      user.email = undefined;
      user.emailVerified = false;
      user.photoURL = undefined;
      user.uid = undefined;
      user.authenticated = false
      eventBus.$emit('onAuthLogout')
    }
    
    globals.user = user
    

    //console.log(globals.user)
    //eventBus.$emit('onUpdateLoginStatus', (user.uid != '' ))

  }, (error) => {
    // console.log(error);
  });
};

const getUser = function getUser() {
  return user;
};

const logout = function logout() {
  firebase.auth().signOut().then(() => {
    // Sign-out successful.
    window.location.reload();
  }, (error) => {
    // An error happened.
    window.location.reload();
  });
};

export default { init, getUser, logout, login };



// WEBPACK FOOTER //
// ./src/auth.js